/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";
import { Box, Text, theme } from "@nordcloud/gnui";
import { FlexContainer } from "~/components";

type CommentContentProps = {
  content: string;
  setHeight: React.Dispatch<React.SetStateAction<number>>;
};

const StyleButtonText = styled(Text)`
  cursor: pointer;
  font-size: ${theme.fontSizes.sm};
  text-decoration: underline;
  margin: 0.5rem 0 0 0;
`;

const TextWrapper = styled(Box)`
  overflow: hidden;
  word-break: break-word;
  white-space: pre-wrap;
`;

function CommentContent({ content, setHeight }: CommentContentProps) {
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

  const ref = React.useRef(null);
  const elRef = React.useCallback(
    (node) => {
      if (node !== null) {
        setHeight(node.current.offsetHeight || 150);
      }
    },
    [setHeight]
  );

  React.useEffect(() => {
    elRef(ref);
  }, [content, setHeight, isExpanded, elRef]);

  return (
    <FlexContainer direction="column" align="flex-end" ref={ref}>
      <TextWrapper boxStyle="lightGrey">
        <Text as="div" m="0">
          {isExpanded || content.length < 100
            ? content
            : `${content.slice(0, 100)}...`}
        </Text>
      </TextWrapper>
      {content.length > 100 && (
        <StyleButtonText onClick={() => setIsExpanded(!isExpanded)}>
          {!isExpanded ? "Show more" : "Show less"}
        </StyleButtonText>
      )}
    </FlexContainer>
  );
}

export { CommentContent };
